<div class="customize-place-category">
    <div>
        <mat-radio-group class="custom-edit-item radio-group" [(ngModel)]="isUseDefault" [disabled]="disabled"
            (ngModelChange)="changeUseDefault()">
            <mat-radio-button [value]="true"> Use default</mat-radio-button>
            <mat-radio-button [value]="false"> Customize</mat-radio-button>
        </mat-radio-group>
    </div>

    <div *ngIf="!isUseDefault&&!disabled">
        <div class="m-b-2 m-t-5">Please organize the place categories on the left side and pick the Google place
            category from the right list</div>
        <div class="m-b-5">You can fold all categories and drag & drop to reorder the list</div>
        <div class="flex relative space-around">
            <div style="width: 38%;">
                <div #editor id="editor-area">
                    <div #accordionItem *ngFor="let item of clientPlaceCategories; let index = index" draggable
                        [dragEnabled]="draggable" [dragScope]="'accordion'" droppable [dropScope]="'accordion'"
                        [dragData]="item" (onDragEnter)="dragEnter($event)" (onDrop)="onItemDrop($event, index)">
                        <ig-accordion-editor [item]="item" [isEditMode]="true" [maxLevels]="3"
                            (onCategoryClick)="selectCategory($event)" (onRemoved)="onSubCategoryRemove($event, item)"
                            (onToggle)="onToggle($event)"
                            (onSubCategoryAdded)="selectedItem=null;syncCategoryListAreaHeightWithEditorAreaHeight()">
                        </ig-accordion-editor>
                    </div>
                    <div class="add-category pointer" (click)="add1stLevelCategory()">+ category</div>
                </div>
            </div>
            <div class="relative">
                <mat-icon class="vertical-middle split-arrow">arrow_forward_ios</mat-icon>
            </div>
            <div #categoryList id="sub-category-wrap">
                <div class="category-locator" [innerHTML]="categoryLocator"></div>
                <div *ngIf="selectedItem" wrapper>
                    <div *ngFor="let category of mergedDefaultCategories" class="m-b-3">
                        <div>{{category.keys[0]}}</div>
                        <hr>
                        <span *ngFor="let sub of category.values">
                            <mat-checkbox [checked]="isSelected(sub)" (change)="defaultCategorySelectionChange($event)"
                                [name]="sub" style="margin-right: 26px">{{showReadable(sub)}}
                            </mat-checkbox>
                            <mat-icon *ngIf="blockGooglePlaceCategories.indexOf(sub)>=0"
                                style="color:lightgray;margin: 0 24px 0 -24px"
                                matTooltip="This category is blocked by admin">info</mat-icon>
                        </span>
                    </div>
                </div>
                <ig-no-content *ngIf="!selectedItem" fontSize="3rem"
                    tip="Please select a category from left"></ig-no-content>
            </div>
        </div>
        <div *ngIf="duplicatedCategories.length">
            <div class="m-t-3">The following categories are duplicated, please select a different name:</div>
            <ul class="m-t-2" *ngFor="let group of duplicatedCategories">
                <li *ngFor="let category of group">{{category}}</li>
            </ul>
        </div>
        <ig-button size="md" [isAsync]="true" color="primary" (trigger)="save($event)">Save</ig-button>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/place.category/customize.place.category.component.html